import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineMinusCircleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 2a10 10 0 1 0 0 20.0001A10 10 0 0 0 12 2Zm0 18a8.0005 8.0005 0 0 1-7.391-4.9385A8 8 0 1 1 12 20Zm4-9H8a1.0001 1.0001 0 0 0-.7071 1.7071C7.4804 12.8946 7.7348 13 8 13h8a1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineMinusCircleIcon
